<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3"><a id="file_025">2. Rolling</a></h3><a id="file_025">
<p class="noindent">Most of the needle-felted animal projects in this book start out with a round shape. Take a palm full of wool and tear it into smaller pieces, layering these pieces one on top of the other. When you have a nice pillow of wool, fold the top edge down and the side edges in <strong>(C)</strong>. Press and fold. Keep folding and pressing the top down and edges in until you have a nice, compact round shape. Needle all around the surface to hold the wool in place. Roll it around in the palm of your hand like a piece of dough.</p>
<p class="image"><img alt="Image" src="images/f0010-03.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_025.vue?037f6660